<template>
    <v-card outlined shaped>
        <v-toolbar dense> 
            <!--<a :href="`/reports/leaktestreport`" ><v-icon aria-hidden="false">mdi-arrow-left</v-icon></a>-->
            <v-btn small color="secundary" @click="goBack"><v-icon aria-hidden="false">mdi-arrow-left</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="printSection">
                <v-icon aria-hidden="false">mdi-printer-pos</v-icon>
                Print
            </v-btn>
        </v-toolbar>
        <br/>
        <div id="printSection" >
            
            <v-card-text>
                <div v-for="building in uniqueBuildings" :key="building">
                 <div v-for="leakGroup in getGroupsByBuilding(building)" :key="leakGroup">
                        <h3>Leak Test Report</h3>
                        <strong>Building: {{building}}  Group:{{leakGroup}}</strong>
                        <v-data-table
                        :headers="headers"
                        :items="buildingSortedItems(building,leakGroup)"
                        :items-per-page="10"
                        class="elevation-1"
                        disable-pagination
                        hide-default-footer>
                        <template v-slot:item.secure="{ item }">
                            <v-text-field v-model="item.secure" ></v-text-field> 
                        </template>
                        <template v-slot:item.sign="{item}">
                            <v-text-field v-model="item.sign"  ></v-text-field>
                        </template>
                        <template v-slot:item.name="{item}">
                            <v-text-field v-model="item.name" ></v-text-field>
                        </template>
                        <template v-slot:item.date="{item}">
                            <v-text-field v-model="item.date" ></v-text-field>
                        </template>    
                        </v-data-table>
                        <div style="page-break-after: always"></div>
                        </div>                    
                    
                </div>
                    
                
                <!--
                    <div id="viewer-host">
                    <JSViewer v-bind:report="{ Uri: '/report.rdlx-json'}"></JSViewer>
                </div>
                -->
            </v-card-text>
        </div>
    </v-card>        
</template>
<script>
    import radiationAPI  from '@/services/radiationservice';
    export default {
        name:'LeakTestReportPrint',
        props:{
            filterTestitems:Array,
            printVisible:Boolean
        },
        data:function(){
            return {
                leakTestGroups:[],
                itemsToDisplay:null
            }
        },
        computed:{
            headers(){
                return [
                    { text: 'Serial' , align: 'start',  value: 'serial'},
                    { text: 'Building', align:'start',  value: 'building'},
                    { text: 'Floor', align:'start',  value: 'floor'},
                    { text: 'Location', align:'start',   value: 'location'},
                    { text: 'Leak Test Group', align: 'start',  value:'leakTestGroup'},
                    //{ text: 'holder', align: 'start' ,  value: 'holder'},
                    //{ text: 'Ref', align: 'start',  value: 'ref'},
                    //{ text: 'Last Device Check', align:'start',  value:'lastCheck'},
                    { text: 'Secure Y / N', align: 'start',  value: 'secure'},
                    { text: 'Caution Sign', align: 'start',  value: 'sign'},
                    { text: 'Name', align: 'start',  value: 'name'},
                    { text: 'Date', align: 'start',  value: 'date'}
                ]
            },
            
            uniqueBuildings(){
                let result=[];
                this.filterTestitems.forEach((item)=>{
                    if(result.indexOf(item.building)<0)
                    {
                        result.push(item.building);
                    }
                });
                console.log("UniqueBuildings");
                return result;
            },
            
            
        },
        mounted:async function(){
            await this.getLeakTestGroup();
        },
        methods:{
            
            async printSection(){
                await  this.$htmlToPaper("printSection");
            },
            async goBack(){
                this.$emit('clicked',false);
            },
            async getLeakTestGroup(){
                
                await radiationAPI.getLeakTestGroups()
                    .then(response=>{
                        this.leakTestGroups=response.data;
                            })
                    .catch(error=>{console.log(error)});
                
            },
            buildingSortedItems(building,leakGroup){
                let result=[];
                //console.log("building",building);
                //console.log("Leak Test Group",leakGroup);
                result=this.filterTestitems.filter((item)=>{
                    return (item.building===building && item.leakTestGroup===leakGroup) 
                });
                //console.log("Items",result)
                return result;

            },
            getGroupsByBuilding(building){

                let buildings= this.filterTestitems.filter((item)=>{
                    return (item.building===building);
                });
                let result=[];
                buildings.forEach((item)=>{
                    if(result.indexOf(item.leakTestGroup)<0)
                    {
                        result.push(item.leakTestGroup);
                    }
                });
                console.log("Unique group by Buildings");
                return result;
            }      
    }
    }
</script>

<style>
    #Viewer-host{
        width: 100%;
        height: 100vh;
    }
</style>




